import script from "./addParcel.vue?vue&type=script&setup=true&lang=js"
export * from "./addParcel.vue?vue&type=script&setup=true&lang=js"

import "./addParcel.vue?vue&type=style&index=0&id=2990dd0c&lang=css"

const __exports__ = script;

export default __exports__